import clsx from "classnames";
import { LucideProps } from "lucide-react";
import React from "react";

import dimensionTokens from "../../../tokens/dimension.value.tokens.json";
import styles from "./index.module.css";

const ICON_SIZE = parseInt(dimensionTokens.component.icon.md.$value);

interface ToastUiProps {
  variant?: "neutral" | "positive" | "alert";
  /** Toast text */
  children?: React.ReactNode;
  /** Tooltip icon */
  icon?: React.ReactElement<LucideProps>;
  /** Additional styles */
  className?: string;
}

/**
 * This is the presentational `ToastUi` element. See `Toast` for the implementation.
 */
const ToastUi: React.FC<ToastUiProps> = ({
  variant = "neutral",
  children,
  icon,
  className,
  ...rest
}) => {
  const classes = clsx(styles.root, styles[variant], className);

  const clonedIcon = icon && React.cloneElement(icon, { size: ICON_SIZE });

  return (
    <div className={classes} {...rest}>
      {clonedIcon && <span className={styles.icon}>{clonedIcon}</span>}
      {children}
    </div>
  );
};

export default ToastUi;
export type { ToastUiProps };
